"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./DueAmount.scss");
var ui_components_1 = require("@idp/ui-components");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var wlsUtils = require("../../../../utils/WirelessUtilFunctions");
var DueAmount = /** @class */ (function (_super) {
    __extends(DueAmount, _super);
    function DueAmount(props) {
        var _this = _super.call(this, props) || this;
        _this.showDueAmount = _this.showDueAmount.bind(_this);
        return _this;
    }
    DueAmount.prototype.render = function () {
        return (React.createElement("div", null, this.showDueAmount()));
    };
    DueAmount.prototype.showDueAmount = function () {
        var promoPriceObj = wlsUtils.promoCyclePriceMsg(this.props.data.duePrice, this.props.data.dueCycle, this.props.data.isPriceNegative);
        return (React.createElement("section", { className: styles.dueContainer },
            React.createElement("article", { className: styles.dueContent },
                React.createElement(ui_components_1.RichText, { testId: 'Due_Today_PromoName', data: { isDecodingRequired: false, text: this.props.data.dueText } })),
            this.props.data.showPrice &&
                React.createElement("article", null,
                    React.createElement(ui_components_1.PriceContainer, { testId: 'Due_Today_Price', data: { billingNote: promoPriceObj.suffix, price: this.props.data.duePrice }, options: { accessibility: promoPriceObj.catoConten, className: styles.duePrice,
                            decimalPoints: 2, isDataPriceNegative: this.props.data.isPriceNegative,
                            overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL } }))));
    };
    return DueAmount;
}(React.Component));
exports.default = DueAmount;
//# sourceMappingURL=DueAmount.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/ExpressView/DueAmount/DueAmount.js
// module id = 415
// module chunks = 8